import { Button } from '@/components/ui/button'
import { Download, FileText, BookOpen } from 'lucide-react'
import { getDossierUrl, getHandbookUrl } from '@/config/dossierUrls'
import type { Role } from './RoleCard'

interface MissionDocumentsProps {
  role: Role
}

export function MissionDocuments({ role }: MissionDocumentsProps) {
  const dossierUrl = getDossierUrl(role)
  const handbookUrl = getHandbookUrl()

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold mb-2 text-[#12356B]">Mission Documents</h2>
        <p className="text-base text-slate-600">
          Download your role-specific dossier and the game handbook for reference.
        </p>
      </div>

      <div className="space-y-4">
        {dossierUrl && (
          <a
            href={dossierUrl}
            target="_blank"
            rel="noopener noreferrer"
            download
            className="flex items-center gap-5 p-5 rounded-xl border border-[#CED4DE] bg-white hover:bg-[#E2E5EC]/40 transition-colors shadow-sm"
          >
            <div className="size-14 rounded-lg bg-[#E2E5EC] flex items-center justify-center text-[#12356B]">
              <FileText className="size-7" />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="font-semibold text-lg text-[#12356B]">{role} Dossier</h3>
              <p className="text-sm text-slate-600">
                Your role-specific information and mission details
              </p>
            </div>
            <Button variant="outline" className="shrink-0 border-[#12356B] text-[#12356B] hover:bg-[#E2E5EC] hover:text-[#12356B]">
              <Download className="size-5 mr-2" />
              Download
            </Button>
          </a>
        )}

        <a
          href={handbookUrl}
          target="_blank"
          rel="noopener noreferrer"
          download
          className="flex items-center gap-5 p-5 rounded-xl border border-[#CED4DE] bg-white hover:bg-[#E2E5EC]/40 transition-colors shadow-sm"
        >
          <div className="size-14 rounded-lg bg-[#E2E5EC] flex items-center justify-center text-[#12356B]">
            <BookOpen className="size-7" />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="font-semibold text-lg text-[#12356B]">Game Handbook</h3>
            <p className="text-sm text-slate-600">
              Complete rules and gameplay instructions
            </p>
          </div>
          <Button variant="outline" className="shrink-0 border-[#12356B] text-[#12356B] hover:bg-[#E2E5EC] hover:text-[#12356B]">
            <Download className="size-5 mr-2" />
            Download
          </Button>
        </a>
      </div>
    </div>
  )
}
